<script setup lang="ts">
import { AppSvgIcon } from '@libs/ui';

import type { HotelAmenityData } from '../../../../core/models';

interface HotelAmenitiesProps {
  amenitiesGroups: HotelAmenityData[][];
}

const props = defineProps<HotelAmenitiesProps>();
</script>

<template>
  <div class="hotel-amenities">
    <div
      v-for="(amentitiesGroup, index) of props.amenitiesGroups"
      :key="index"
      class="amenities-group"
    >
      <div
        v-for="amenity in amentitiesGroup"
        :key="amenity.value"
        class="hotel-amenity"
      >
        <AppSvgIcon :name="amenity.icon" color="color-neutral-70" />
        <span class="amenity-text">{{ amenity.value }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.hotel-amenities {
  display: flex;
  gap: var(--spacing-64);

  .amenities-group {
    display: flex;
    flex-flow: column;
    gap: var(--spacing-8);

    .hotel-amenity {
      display: flex;
      align-items: center;
      gap: var(--spacing-8);

      .amenity-text {
        color: var(--color-neutral-70);
        @include font-body-l-light;
      }
    }
  }
}
</style>
